export default "__VITE_ASSET__DmOEha9D__"